

import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  TextField,
} from "@mui/material";

const DeleteApplicantModal = ({ open, onClose, onDelete, applicant }) => {
  const [confirmation, setConfirmation] = useState("");
  const [loading, setLoading] = useState(false);

  if (!applicant) return null;

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>Borrar Solicitud</DialogTitle>
      <DialogContent>
        <Typography variant="body1" gutterBottom>
          ¿Estás seguro que deseas borrar la solicitud de:
        </Typography>
        <Typography variant="h6" color="error">
          {applicant.nombre} {applicant.apellido}
        </Typography>
        <Typography variant="body2" sx={{ mt: 2 }}>
          Escribí <strong>“borrar”</strong> para confirmar.
        </Typography>
        <TextField
          fullWidth
          margin="normal"
          variant="outlined"
          value={confirmation}
          onChange={(e) => setConfirmation(e.target.value)}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="inherit">
          Cancelar
        </Button>
        <Button
          onClick={async () => {
            setLoading(true);
            try {
              await onDelete(applicant);
              setConfirmation("");
            } finally {
              setLoading(false);
            }
          }}
          color="error"
          variant="contained"
          disabled={confirmation.toLowerCase() !== "borrar" || loading}
        >
          {loading ? "Borrando..." : "Confirmar Borrado"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteApplicantModal;